<template>
    <Frame>
        <PageHeader :title="$t('OrderArrivalDetail.orderDetail')" :hasBack="true" />
        <div class="header-contain" ref="headContain">
            <div class="title-row">
                <span>{{ $t('comm.messagetitle') }}</span>
            </div>
            <div class="head-fields">
                <div class="field">{{ $t('OrderArrivalDetail.BillNo') + BillNo }}</div>
                <div class="field">{{ $t('OrderArrivalDetail.BillDate') + BillDate }}</div>
                <div class="field">{{ $t('OrderArrivalDetail.BizPartnerName') + BizPartnerName }}</div>
                <div class="field">{{ $t('OrderArrivalDetail.OAmount') + OAmount }}</div>
            </div>
            <div class="title-row" style="margin:16px 0">
                <span>{{ $t('comm.detailtitle') }}</span>
            </div>
        </div>
        <el-table :data="tableData" style="margin:0;width:100%;color:#777777;font-size:14px;" :height="tableHeight"
            v-loading="tableLoading">
            <el-table-column prop="SaleBillNo" :min-width="WidthControl('SaleBillNo', tableData)" :label="$t('OrderArrivalDetail.orderBillNo')"></el-table-column>
            <el-table-column prop="X_Or" :min-width="WidthControl('X_Or', tableData)" label="OR"></el-table-column>
            <el-table-column prop="X_CustNumberOrg" :min-width="WidthControl('X_CustNumberOrg', tableData)":label="$t('salSalesOrder.customerNo')"></el-table-column>
            <el-table-column prop="BPMaterialId" :min-width="WidthControl('BPMaterialId', tableData)" label="ItemCode"></el-table-column>
            <el-table-column prop="BPMaterialName" :min-width="WidthControl('BPMaterialName', tableData)" label="ItemName"></el-table-column>
            <el-table-column prop="X_ColorId" :min-width="WidthControl('X_ColorId', tableData)":label="$t('OrderArrivalDetail.color')"></el-table-column>
            <el-table-column prop="X_Length" :min-width="WidthControl('X_Length', tableData)":label="$t('OrderArrivalDetail.length')"></el-table-column>
            <el-table-column prop="X_LUnitId" :min-width="WidthControl('X_LUnitId', tableData)" :label="$t('OrderArrivalDetail.lengthUnit')"></el-table-column>
            <el-table-column prop="BatchNo" :min-width="WidthControl('BatchNo', tableData)" :label="$t('OrderArrivalDetail.batchNo')"></el-table-column>
            <el-table-column prop="ReceivingSQty" :min-width="WidthControl('ReceivingSQty', tableData)" align="right" :label="$t('OrderArrivalDetail.SQuantity')"></el-table-column>
            <el-table-column prop="ReciveDate" :min-width="WidthControl('ReciveDate', tableData)" :label="$t('OrderArrivalDetail.ArrivalData')"></el-table-column>
            <el-table-column prop="X_Addr" :min-width="WidthControl('X_Addr', tableData)" :label="$t('OrderArrivalDetail.ArrivalAddress')"></el-table-column>
        </el-table>
    </Frame>
</template>
<script>
import { detailMixin } from '@/agency/mixin/mixin'
export default {
    mixins: [detailMixin],
    data() {
        return {
            BillDate: '',
            BizPartnerName: '',
            OAmount: ''
        }
    },
    props: {
        GetOrderDetail: {
            type: Function,
            default: function () {
                this.getOrderDetail();
            }
        }
    },
    mounted() {
        //因为需要计算表头高度，所以要拿到ref以后才可以去计算高度，所以要放在mounted上，提前钩子到created会有高度计算bug
        this.GetOrderDetail();
    },
    methods: {
        getOrderDetail() {
            this.tableLoading = true;
            this.axiosInvoke(this.YMBillHandlerUrl, {
                action: 'getorderarrivallistdetail',
                FromOrderBillNo:this.BillNo
            }, (res, err) => {
                if (!err) {
                    const data = res.data;
                    const headTable = data.headTable;
                    this.BillDate = headTable.BillDate;
                    this.BizPartnerName = headTable.BizPartnerName;
                    this.OAmount = headTable.OAmountWithTax ;
                    this.tableLoading = false;
                    this.tableData = data.bodyTable;
                    //二开本方法时，请记得带上下面这段页面resize监听代码
                    this.$nextTick(() => {
                        this.frameOnResize(150);
                    })
                }

            })
        }
    }
}
</script>
<style scoped>
.header-contain {
    display: flex;
    padding: 0 30px;
    width: calc(100% - 60px);
    padding-top: 38px;
    flex-wrap: wrap;
}

.title-row {
    color: #5d5d5d;
    font-size: 16px;
    width: 20%;
    display: flex;
    justify-content: space-between;
    width: 100%;

}

.fun-buttons {
    width: 40%;
    display: flex;
    justify-content: flex-end;
    padding-right: 10%;
}

.button {
    color: #5d5d5d;
    font-size: 15px;
    cursor: pointer;
    white-space: nowrap;
}

.button:hover {
    cursor: pointer;
    color: #0177d5;
}

.option-icon {
    filter: grayscale(100%);
    margin: 0 2.5%;
}

.option-icon:hover {
    filter: grayscale(0%);
}

.field {
    color: #777;
    font-size: 14px;
    width: 24%;
    padding-top: 14px;
    margin-right: 1%;
    word-break: break-all;
    max-height: 150px;
    overflow: auto;
}

.head-fields {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
}

.el-table /deep/ th.el-table__cell {
    background-color: #f9f9f9;
}

.el-table /deep/ .el-table__body-wrapper {
    font-size: 13px;
}

.el-table /deep/ thead {
    font-size: 14px;
    color: #777777;
}

.el-table /deep/ .el-table_1_column_1 .cell:first-child {
    padding: 0 0 0 30px;
}

.el-table /deep/ .cell:first-child {
    font-weight: normal;
}
</style>
